import { render, staticRenderFns } from "./SkeletonMobilesViewsHistoryCard.vue?vue&type=template&id=22b17706"
import script from "./SkeletonMobilesViewsHistoryCard.vue?vue&type=script&lang=js"
export * from "./SkeletonMobilesViewsHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports